// src/Components/Admin/AdminNavbar.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './admin.css';
import AdminNotifications from './AdminNotifications';

const AdminNavbar = ({ onLogout }) => {
    const navigate = useNavigate();

    return (
        <nav className="admin-navbar">
            <div className="admin-brand">
                <Link to="/admin/dashboard">Admin Panel</Link>
            </div>
            <div className="admin-nav-links">
                <Link to="/admin/dashboard">Dashboard</Link>
                <Link to="/admin/events">Manage Events</Link>
                <Link to="/admin/bookings">Manage Bookings</Link>
                <Link to="/admin/change-role">Change User Role</Link>
                <AdminNotifications />
                <button
                    className="nav-link-btn"
                    onClick={() => {
                        onLogout();
                        navigate('/');
                    }}
                >
                    Logout
                </button>
            </div>
        </nav>
    );
};

export default AdminNavbar;